/**
 * Comparisons on file paths held as segment arrays. A folder or file name can
 * contain "/", so a path is never joined into a string to be compared:
 * `["a/b"]` and `["a", "b"]` are different paths.
 */

export function pathsEqual(
  a: readonly string[],
  b: readonly string[]
): boolean {
  return a.length === b.length && a.every((segment, i) => segment === b[i]);
}

/** True when `prefix` is `path` or one of its ancestors. */
export function isPathPrefix(
  prefix: readonly string[],
  path: readonly string[]
): boolean {
  return (
    prefix.length <= path.length &&
    prefix.every((segment, i) => segment === path[i])
  );
}
